// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1jcsp1a0 {
  width: 100%;
}
._1jcsp1a1 {
  position: absolute;
  top: 40%;
  right: 12.5%;
  width: 25%;
  padding: 2%;
}
._1jcsp1a2 {
  background: var(--_18w76bw23);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);
  position: relative;
  padding: 2%;
}
._1jcsp1a3 {
  width: 100%;
}
._1jcsp1a4 {
  cursor: not-allowed;
}
._1jcsp1a4:disabled {
  pointer-events: auto;
}
@media screen and (min-width: 768px) {
  ._1jcsp1a0 {
    width: calc(66.66% - 24px);
  }
  ._1jcsp1a3 {
    width: 33.33%;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["._1jcsp1a0 {\n  width: 100%;\n}\n._1jcsp1a1 {\n  position: absolute;\n  top: 40%;\n  right: 12.5%;\n  width: 25%;\n  padding: 2%;\n}\n._1jcsp1a2 {\n  background: var(--_18w76bw23);\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 39%);\n  position: relative;\n  padding: 2%;\n}\n._1jcsp1a3 {\n  width: 100%;\n}\n._1jcsp1a4 {\n  cursor: not-allowed;\n}\n._1jcsp1a4:disabled {\n  pointer-events: auto;\n}\n@media screen and (min-width: 768px) {\n  ._1jcsp1a0 {\n    width: calc(66.66% - 24px);\n  }\n  ._1jcsp1a3 {\n    width: 33.33%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
